// extracted by mini-css-extract-plugin
export default {"mpQuerySamplingCta":"mp-query-sampling-cta__g7x_ta9w"};